<av-tooltip message="Pointer color" position="bottom">
  <div class="point" #point></div>
</av-tooltip>
